import { render, staticRenderFns } from "./searchGoods.vue?vue&type=template&id=54b18492&scoped=true&"
import script from "./searchGoods.vue?vue&type=script&lang=js&"
export * from "./searchGoods.vue?vue&type=script&lang=js&"
import style0 from "./searchGoods.vue?vue&type=style&index=0&id=54b18492&lang=less&scoped=true&"
import style1 from "./searchGoods.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b18492",
  null
  
)

component.options.__file = "searchGoods.vue"
export default component.exports